import React, { useEffect } from 'react';
import { Button, Card, FloatingLabel, Form } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';

function DatepickerFiltre({ startDate, endDate, onChange }) {
  return (
    <DatePicker
      popperPlacement="bottom-start"
      selected={startDate}
      onChange={onChange}
      startDate={startDate}
      endDate={endDate}
      formatWeekDay={day => day.slice(0, 3)}
      selectsRange
      dateFormat="dd/MM/YYYY"
      className="form-control"
      onKeyDown={e => e.preventDefault()}
    />
  );
}

DatepickerFiltre.propTypes = {
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};

const ProduitsFilteringForm = ({
  onFilterUpdate,
  filterState,
  fetchEntetes,
  entetesLoading,
  secteur,
  categorie,
  famille,
}) => {
  const user = useSelector(state => state.auth.user);
  const onDateChange = dates => {
    const [start, end] = dates;
    onFilterUpdate({
      ...filterState,
      startDate: start,
      endDate: end,
    });
  };

  const resetFilter = () => {
    const defaultState = {
      selectedMagasin: user.magasin === 'Tous' ? 'Tous' : user.magasin,
      selectedChoix: 'Tous',
      selectedType: user.magasin === 'Tous' ? 'Tous' : user.magasin,
      selectedTypeReglement: user.magasin === 'Tous' ? 'Tous' : user.magasin,
      startDate: new Date().toISOString(),
      endDate: new Date().toISOString(),
      client: '',
      typeTransaction: 'Tous',
      remisePromo: '',
    };
    onFilterUpdate(defaultState);
  };

  const handleSelectChange = selectedOption => {
    onFilterUpdate({
      ...filterState,
      selectedMagasin: selectedOption?.value || '',
    });
  };

  const handleSelectSecteur = selectedOption => {
    onFilterUpdate({
      ...filterState,
      secteur: selectedOption?.value || '',
    });
  };

  const handleSelectCategorie = selectedOption => {
    onFilterUpdate({
      ...filterState,
      categorie: selectedOption?.value || '',
    });
  };

  const handleSelectFamille = selectedOption => {
    onFilterUpdate({
      ...filterState,
      famille: selectedOption?.value || '',
    });
  };

  const handleSelectTypeReglement = selectedOption => {
    onFilterUpdate({
      ...filterState,
      selectedTypeReglement: selectedOption?.value || '',
    });
  };

  const handleSelectTypeTransaction = selectedOption => {
    onFilterUpdate({
      ...filterState,
      typeTransaction: selectedOption?.value || '',
    });
  };

  const handleUpdate = () => {
    fetchEntetes();
  };

  // Helper function to find the option object by value
  const findOptionByValue = (options, value) => {
    if (!value) return null;
    return options.find(option => option.value === value) || null;
  };

  return (
    <Card className="shadow-none shadow-show-xl scrollbar">
      <Card.Header className="bg-body-tertiary d-none d-xl-block">
        <h6 className="mb-0 me-3 d-inline-block">Filter</h6>
        <IconButton
          variant="primary"
          iconClassName="me-2"
          icon="minus"
          // transform="shrink-3"
          size="sm"
          onClick={resetFilter}
        >
          Réinitialiser filtre
        </IconButton>
      </Card.Header>
      <Card.Body>
        <Form>
          <div className="mb-2 mt-n2">
            <FloatingLabel controlId="floatingSelect" label="Statut" className="mb-1 fs-10">
              <Form.Select
                size="sm"
                // defaultValue={filterState.selectedMagasin}
                onChange={handleSelectChange}
                // value={user.magasin === 'Tous' ? filterState.selectedMagasin : user.magasin}
                // disabled={user.magasin !== 'Tous'}
              >
                <option>Tous</option>
                <option>ACTIF</option>
                <option>INACTIF</option>
              </Form.Select>
            </FloatingLabel>
          </div>
          <div className="mb-2 mt-3">
            <FloatingLabel controlId="floatingInput" label="Produit" className="mb-3">
              <Form.Control
                type="text"
                // value={filterState.client}
                onChange={e => onFilterUpdate({ ...filterState, produit: e.target.value })}
              />
            </FloatingLabel>
          </div>

          <div className="mb-2">
            <Form.Label className="mb-1 mt-2 fs-10">Date Modification</Form.Label>
            <DatepickerFiltre
              //   startDate={filterState.startDate}
              //   endDate={filterState.endDate}
              onChange={onDateChange}
            />
          </div>
          <div className="mb-2 mt-n2">
            <Form.Label className="mb-1 mt-2 fs-10">Secteur</Form.Label>
            <Select
              // size="sm"
              // defaultValue={filterState.selectedChoix}
              onChange={handleSelectSecteur}
              value={findOptionByValue(secteur, filterState.secteur)}
              options={secteur}
              isClearable
            />
          </div>
          <div className="mb-2 mt-n2">
            <Form.Label className="mb-1 mt-2 fs-10">Catégorie</Form.Label>
            <Select
              // size="sm"
              // defaultValue={filterState.selectedChoix}
              onChange={handleSelectCategorie}
              value={findOptionByValue(categorie, filterState.categorie)}
              options={categorie}
              isClearable
            />
          </div>
          <div className="mb-2 mt-n2">
            <Form.Label className="mb-1 mt-2 fs-10">Famille</Form.Label>
            <Select
              // size="sm"
              // defaultValue={filterState.selectedChoix}
              onChange={handleSelectFamille}
              value={findOptionByValue(famille, filterState.famille)}
              options={famille}
              isClearable
            />
          </div>

          <div className="mb-2 mt-n2">
            <Form.Label className="mb-1 mt-2 fs-10">Remise max</Form.Label>
            <Form.Control
              type="text"
              value={filterState.remisemax}
              onChange={e => onFilterUpdate({ ...filterState, remisemax: e.target.value })}
            />
          </div>
          <div className="mb-2 mt-n2">
            <Form.Label className="mb-1 mt-2 fs-10">Remise convention</Form.Label>
            <Form.Control
              type="text"
              value={filterState.remiseMaxConvention}
              onChange={e =>
                onFilterUpdate({ ...filterState, remiseMaxConvention: e.target.value })
              }
            />
          </div>
          <div className="mb-2 mt-n2">
            <Form.Label className="mb-1 mt-2 fs-10">Remise promotion</Form.Label>
            <Form.Control
              type="text"
              value={filterState.remisePromo}
              onChange={e => onFilterUpdate({ ...filterState, remisePromo: e.target.value })}
            />
          </div>
        </Form>
      </Card.Body>
      <Card.Footer className="border-top border-200 py-1">
        <Button varient="primary" className="w-100" onClick={handleUpdate}>
          {entetesLoading ? (
            <div className="d-flex align-items-center justify-content-center gap-2">
              <Spinner animation="border" size="sm" /> <span>Chargement...</span>
            </div>
          ) : (
            'Récupérer'
          )}
        </Button>
      </Card.Footer>
    </Card>
  );
};

ProduitsFilteringForm.propTypes = {
  onFilterUpdate: PropTypes.func.isRequired,
  filterState: PropTypes.object,
  fetchEntetes: PropTypes.func.isRequired,
};
export default ProduitsFilteringForm;
